import React from 'react';
import styles from './GateLivestreamPlusListItem.module.css';
import IconPlusCheckMark from './IconPlusCheckMark.js';
import PropTypes from 'prop-types';

const GateLivestreamPlusListItem = ({ text }) => (
  <li className={styles.textList}>
    <span className={styles.checkmark}>
      <IconPlusCheckMark />
    </span>
    <span className={styles.featureText}>{text}</span>
  </li>
);

GateLivestreamPlusListItem.displayName = 'GatePlusTextListItem';

GateLivestreamPlusListItem.propTypes = {
  text: PropTypes.string,
};

export default GateLivestreamPlusListItem;
